import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS - 3);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: hours,
    suffix: 'hrs'
  }, {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-red-500 text-white" data-id="element-34" data-mp="aob20q981w0c">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-1.5 whitespace-nowrap px-3 py-1 text-[9px] font-bold uppercase leading-none tracking-[0.08em] sm:gap-2 sm:px-4 sm:py-2 sm:text-xs sm:tracking-[0.14em]" data-id="element-35" data-mp="6mzkz94eyj3r">
        <HourglassIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-36" data-mp="18eojr8xq9d9b" />
        <span data-id="element-37" data-mp="uenm02crely2">Launch offer ends in:</span>
        <span className="flex items-center gap-0.5 tabular-nums sm:gap-1" aria-live="off" data-id="element-38" data-mp="ufozsel5tmjh">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-0.5 sm:gap-1" data-id="element-39" data-mp="1m4s41ud1qww4" data-mpi={index}>
              <span className="text-xs font-extrabold sm:text-base" data-id="element-40" data-mp="1r3lhjmsc2nwa">
                {pad(unit.value)}
              </span>
              <span className="text-[8px] tracking-normal opacity-90 sm:text-[9px]" data-id="element-41" data-mp="1dcq5y2qg9sp0">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="px-0.5 opacity-70" data-id="element-42" data-mp="1hbfe9gwmsk1s">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}